import React, { Component } from 'react';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { Button } from 'react-bootstrap';

const progressCellRenderer = (value, rate) => {
	var html = "";
    
    html+= '<div class="progress-small">'
    html+= "    <div class='progress-title' style='text-align : center'>"+ value + "</div>"
    html+= '    <div class="progress text-center" style="">'
    html+= '        <span class="progress-value">' + rate + '%</span>'
    html+= '        <div class="progress-bar" role="progressbar" style="width: ' + rate + '%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"/>'
    html+= '    </div>'
    html+= '</div>'

	return html;
}
class BranchBizareaInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			year : this.props.year,
			branch : null,
			tableData : null,
            total_biz_branch: 0,
            total_not_biz_branch: 0,
		}
	}


    componentWillReceiveProps = (nextProps) => {
        this.setState({
            branch : nextProps.branch
        }, () => {
        	this.setState({tableData: this.listClean()});
        })
    }

    // 영업지역이 아닌 경우 해당 년도에 계약된 원/어린이집이 없는 경우 리스트에서 제외
	listClean = () => {

        var list = this.state.branch === null ? null : this.state.branch.bizs;
        var tableData = [];
        this.state.total_biz_branch = this.state.total_not_biz_branch = 0
        if(list !== null) {
            for(var i = 0; i < list.length; i++) {
                if (list[i].contract !== null && list[i].contract[this.props.year].TOTAL > 0) {
                    if(list[i].is_biz_area)
                        this.state.total_biz_branch++
                    else
                        this.state.total_not_biz_branch++
                    tableData.push(list[i]);
                }
            }
        }
		return tableData;
	}

    onBranchBizareaSelect() {
        //this.props.onLocaleBranchSelectHandler(this.props.loc_info.bizs.find(biz => biz.branch.ID == branch_id).branch);
        var selectedRows = this.gridApi.getSelectedRows();
        if (selectedRows != null && selectedRows.length > 0) {
            var loc_info = this.props.loc_infos.find(l => l.CODE == selectedRows[0].LOC_CODE)
            this.props.onBranchBizareaSelectHandler(loc_info);
        }
    }

    onBranchDetailClick() {
    	document.location.href = "/map/branch?id=" + this.props.branch.ID + "&year="+this.props.year;
    }

    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onFirstDataRendered = params => {
        params.api.sizeColumnsToFit();
    }

    rendererLocaleName = (param) => {
        var loc_info = this.props.loc_infos.find(l => l.CODE == param.LOC_CODE)
        return (loc_info.PARENT_NAME_SIDO ? loc_info.PARENT_NAME_SIDO + ' ' + (loc_info.PARENT_NAME_SIGUNGU ? loc_info.PARENT_NAME_SIGUNGU + ' ' : '') : '') + loc_info.NAME
    }

    defaultColDef = {
        resizable : false,
        editable: false,
        headerClass:'bg-dark text-light',
        suppressMovable: true
    };
    listColumn = [
        {
            headerName: "지역",
            field: "branch.NAME",
            sortable: true,
            minWidth: 130,
            cellClass: function (param) { return param.data.is_biz_area ? "text-center text-success" : "text-center text-danger" },
            cellRenderer: (param) => {
                //return (param.data.is_biz_area ? '' : '<i class="fas fa-exclamation-circle"></i> ') + this.rendererLocaleName(param.data)
                return this.rendererLocaleName(param.data)
            },
        },
        {
            headerName: "전체",
            sortable: true,
            cellClass: "text-center",
            valueGetter: (param) => {
                return param.data.contract === null ? 0 : (param.data.contract[this.props.year].TOTAL)
            },
        },
        {
            headerName: "신규",
            sortable: true,
            cellClass: "text-center",
            valueGetter: (param) => {
                return param.data.contract === null ? 0 : (param.data.contract[this.props.year].NURSERY_NEW + param.data.contract[this.props.year].DAYCARE_NEW + param.data.contract[this.props.year].NULL_NEW)
            },
        },
        // {
        //     headerName: "재계약",
        //     sortable: true,
        //     cellClass: "text-center",
        //     valueGetter: (param) => {
        //         return param.data.contract === null ? 0 : (param.data.contract[this.props.year].NURSERY_RENEW + param.data.contract[this.props.year].DAYCARE_RENEW + param.data.contract[this.props.year].NULL_RENEW)
        //     },
        // },
        {
            headerName: "재계약",
            sortable: true,
            cellClass: "text-center",
            valueGetter: (param) => {
                return (param.data.contract == null ? 0 : param.data.contract[this.props.year].RATE_RENEW);
            },
            cellRenderer: (param) => {
                return progressCellRenderer((param.data.contract[this.props.year].NURSERY_RENEW + param.data.contract[this.props.year].DAYCARE_RENEW + param.data.contract[this.props.year].NULL_RENEW).toLocaleString()
                         + ' / ' + (this.props.year > 2017 ? param.data.contract[this.props.year - 1].TOTAL : 0).toLocaleString(), 
                         param.value);
            }
        },
        {
            headerName: "지사점유율",
            sortable: true,
            cellClass: "text-center",
            valueGetter: (param) => {
                return (param.data.contract == null ? 0 : param.data.contract[this.props.year].RATE_SHARE);
            },            
            cellRenderer: (param) => {
                return progressCellRenderer((param.data.contract[this.props.year].TOTAL).toLocaleString()
                         + ' / ' + (this.props.year > 2017 ? this.props.loc_infos.find(loc=>loc.CODE === param.data.LOC_CODE).contract[this.props.year].TOTAL : 0).toLocaleString(), 
                         param.value);
            }
        },
    ];

    render() {

        return (
            <div className="card border-top border-3 border-top-warning" style={{ height: (this.props.height) + "px" }}>
				<div className="card-header d-flex">
                    {(this.props.branch !== null) ? (
                        <div className="row" style={{width:"100%"}}>
                            <div className="col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12">
                                <h5 className="card-header-title">
                                    {this.props.branch.NAME}
                                    <span style={{fontSize:"12px", marginLeft:"10px"}}>
                                        {(this.state.total_biz_branch > 0) ? (
                                            <span className="text-success">관내 {this.state.total_biz_branch}</span>
                                        ) : ''}
                                        {(this.state.total_not_biz_branch > 0) ? (
                                            <span style={{marginLeft:"10px"}} className="text-danger">관외 {this.state.total_not_biz_branch}</span>
                                        ) : ''}
                                    </span>
                                </h5>
                            </div>
                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 text-right" style={{lineHeight:2, paddingRight:"0px"}}>
                                <Button variant="outline-dark" size='sm' onClick={this.onBranchDetailClick.bind(this)}>자세히 <i className="fas fa-chevron-right"></i></Button> 
                            </div>
                        </div>
                    ) : (
                        <h5 className="card-header-title">
                            &nbsp;
                        </h5>
                    )}
                </div>
                <div className="card-body" style={{ padding: "0px", textAlign: "center", overflow: "auto" }}>
                    {(this.state.branch === null && this.props.loc_infos === null) ? (
                        <span className="dashboard-spinner spinner-xxl" style={{ marginTop: "50px" }}></span>
                    ) : ((this.state.branch === null && this.props.loc_infos !== null) ? (
                        <div className="text-center align-middle" style={{ width: "100%", height: "100%", padding: "70px 0" }}>No data</div>
                    ) : (
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ag-theme-balham" style={{ height: (this.props.height - 61) + "px", width: "100%", padding: "0px" }}>
                                <AgGridReact
                                    columnDefs={this.listColumn}
                                    defaultColDef={this.defaultColDef}
                                    rowData={this.state.tableData}
                                    rowHeight={40}
                                    rowSelection="single"
                                    onGridReady={this.onGridReady}
                                    onSelectionChanged={this.onBranchBizareaSelect.bind(this)}
                                    onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                                >
                                </AgGridReact>
                            </div>
                        )
                        )}
                </div>
            </div>
        )

    }

}


export default BranchBizareaInfo;